import {BaseAnimation} from './BaseAnimation';

export class HeightAnimation extends BaseAnimation {

    private fromValue:number|'auto'|null=null;
    private toValue:number|'max'|'auto'|null=null;

    public getClass():string {
        return 'height-animation';
    }

    public from(value:number|'auto') {
        this.fromValue=value;
        if (value=='auto') {
            if (this.initialDisplay=='none') value=0; else value=this.element.height()??0;
        }
        this.fromItem.css('height',value);
        return this;
    }

    protected isValidProperty(prop:string) {
        return prop=='height';
    }

    public before() {
        if (this.fromValue===null) this.from('auto');
        if (this.toValue===null) this.to('auto');
    }

    public after() {
        super.after();
        if (this.toValue=='auto') this.element.css('height','auto');
        if (this.toValue==0) this.element.css('display','');
    }

    public to(value:number|'max'|'auto') {
        this.toValue=value;
        if (value=='auto' || value=='max') {
            var oldheight=this.element.css('height');
            this.element.css('height','');
            var maxheight;
            if (value=='max') {
                let winh=$(window).height()??0;
                maxheight=winh-this.element[0].getBoundingClientRect().top;
            } else {
                maxheight=Number.MAX_VALUE;
            }
            value=this.element.height()??0;
            value=Math.min(value,maxheight);

            this.element.css('height',oldheight);
        }
        this.toItem.css('height',value);
        return this;
    }

}

export {};